// import { Theme } from '@/types/app'
import { useTheme as useBaseTheme } from 'next-themes'

const useTheme = () => {
  const { theme, resolvedTheme, ...rest } = useBaseTheme()
  return {
    // only returns 'light' or 'dark' theme
    // 犹豫主题存在兼容性问题，写死返回 light
    theme: 'light', // theme === Theme.system ? resolvedTheme as Theme : theme as Theme,
    ...rest,
  }
}

export default useTheme
